/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getAppList = /* GraphQL */ `query GetAppList {
  getAppList
}
` as GeneratedQuery<
  APITypes.GetAppListQueryVariables,
  APITypes.GetAppListQuery
>;
export const listParticipants = /* GraphQL */ `query ListParticipants($data: AWSJSON) {
  listParticipants(data: $data)
}
` as GeneratedQuery<
  APITypes.ListParticipantsQueryVariables,
  APITypes.ListParticipantsQuery
>;
export const listVideoContent = /* GraphQL */ `query ListVideoContent {
  listVideoContent
}
` as GeneratedQuery<
  APITypes.ListVideoContentQueryVariables,
  APITypes.ListVideoContentQuery
>;
export const validateLockPIN = /* GraphQL */ `query ValidateLockPIN($params: AWSJSON) {
  validateLockPIN(params: $params)
}
` as GeneratedQuery<
  APITypes.ValidateLockPINQueryVariables,
  APITypes.ValidateLockPINQuery
>;
export const fetchProactiveMessages = /* GraphQL */ `query FetchProactiveMessages($username: String, $application_id: Int) {
  fetchProactiveMessages(username: $username, application_id: $application_id)
}
` as GeneratedQuery<
  APITypes.FetchProactiveMessagesQueryVariables,
  APITypes.FetchProactiveMessagesQuery
>;
export const getWeather = /* GraphQL */ `query GetWeather(
  $latitude: Float
  $longitude: Float
  $location: String
  $date: String
) {
  getWeather(
    latitude: $latitude
    longitude: $longitude
    location: $location
    date: $date
  )
}
` as GeneratedQuery<
  APITypes.GetWeatherQueryVariables,
  APITypes.GetWeatherQuery
>;
export const getState = /* GraphQL */ `query GetState($data: AWSJSON) {
  getState(data: $data)
}
` as GeneratedQuery<APITypes.GetStateQueryVariables, APITypes.GetStateQuery>;
export const getAlarm = /* GraphQL */ `query GetAlarm($id: ID!) {
  getAlarm(id: $id) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAlarmQueryVariables, APITypes.GetAlarmQuery>;
export const listAlarms = /* GraphQL */ `query ListAlarms(
  $filter: ModelAlarmFilterInput
  $limit: Int
  $nextToken: String
) {
  listAlarms(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      participantIDS
      checklist
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      color
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAlarmsQueryVariables,
  APITypes.ListAlarmsQuery
>;
export const getAlert = /* GraphQL */ `query GetAlert($id: ID!) {
  getAlert(id: $id) {
    id
    habitatID
    emoji
    title
    type
    start
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    participantIDS
    checklist
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    goalID
    goal {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    color
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetAlertQueryVariables, APITypes.GetAlertQuery>;
export const listAlerts = /* GraphQL */ `query ListAlerts(
  $filter: ModelAlertFilterInput
  $limit: Int
  $nextToken: String
) {
  listAlerts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      participantIDS
      checklist
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      goalID
      goal {
        id
        habitatID
        emoji
        title
        type
        start
        end
        allDay
        recurrence {
          mode
          freq
          interval
          byweekday
          until
          count
          __typename
        }
        recurrenceUntil
        recurrenceInstanceMap
        recurrenceExcludeDates
        location
        principal {
          id
          sub
          name
          location
          username
          primary
          habitatID
          role
          email
          phoneNumber
          NDISAccountName
          NDISNumber
          birthday
          planManagerName
          planManagerEmail
          emailVerified
          carerPhone
          carerName
          supportWorkerPhone
          supportWorkerName
          contacts
          favouriteContacts
          address {
            type
            street
            city
            state
            postcode
            country
            __typename
          }
          profileColor
          profilePicture
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          customPictureURL
          systemPreferences {
            androidNotificationSoundID
            androidAlarmSoundID
            __typename
          }
          scheduledMessages {
            nextToken
            __typename
          }
          endpointIds
          hasCompletedMealOnboarding
          hasViewedMealSection
          hasViewedGoalSection
          recipePreferenceOptionIDs
          onboardingToken
          hasOnboarded
          skippedOnboardingWizard
          onboardingRecipeChoices
          dashboardLayoutPreset
          chatApplicationId
          people
          budget
          time_and_effort
          dietary_balance
          allergies
          prepTime
          avoidances {
            category
            degree
            __typename
          }
          skillLevel
          is_child_profile
          use_generative_ai {
            name
            model
            max_tokens
            temperature
            __typename
          }
          favourite_recipe_ids
          contact_id
          createdAt
          updatedAt
          __typename
        }
        principalID
        participantIDS
        checklist
        todo
        notes
        complete
        recurrenceCompletionStates
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        imageURL
        completions
        completions_per_period
        period
        reference_code
        readGroups
        isTemplate
        category_ids
        color
        owner
        createdAt
        updatedAt
        __typename
      }
      color
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAlertsQueryVariables,
  APITypes.ListAlertsQuery
>;
export const getEvent = /* GraphQL */ `query GetEvent($id: ID!) {
  getEvent(id: $id) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence_rule
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    color
    tags
    reminders
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetEventQueryVariables, APITypes.GetEventQuery>;
export const listEvents = /* GraphQL */ `query ListEvents(
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      color
      tags
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEventsQueryVariables,
  APITypes.ListEventsQuery
>;
export const getMeal = /* GraphQL */ `query GetMeal($id: ID!) {
  getMeal(id: $id) {
    id
    habitatID
    emoji
    title
    type
    mealType
    start
    end
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    ingredients {
      id
      title
      checked
      shoppingListID
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    notes
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    recipes {
      items {
        id
        mealID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    eaten
    recommended
    acceptedRecommended
    skipped
    meal_plan_id
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetMealQueryVariables, APITypes.GetMealQuery>;
export const listMeals = /* GraphQL */ `query ListMeals(
  $filter: ModelMealFilterInput
  $limit: Int
  $nextToken: String
) {
  listMeals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      mealType
      start
      end
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      ingredients {
        id
        title
        checked
        shoppingListID
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      recipes {
        items {
          id
          mealID
          recipeID
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      eaten
      recommended
      acceptedRecommended
      skipped
      meal_plan_id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListMealsQueryVariables, APITypes.ListMealsQuery>;
export const getDashboard = /* GraphQL */ `query GetDashboard($id: ID!) {
  getDashboard(id: $id) {
    id
    name
    description
    device_type
    user_id
    read_accounts
    read_groups
    full_access_groups
    layout
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDashboardQueryVariables,
  APITypes.GetDashboardQuery
>;
export const listDashboards = /* GraphQL */ `query ListDashboards(
  $filter: ModelDashboardFilterInput
  $limit: Int
  $nextToken: String
) {
  listDashboards(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      device_type
      user_id
      read_accounts
      read_groups
      full_access_groups
      layout
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDashboardsQueryVariables,
  APITypes.ListDashboardsQuery
>;
export const getDomain = /* GraphQL */ `query GetDomain($id: ID!) {
  getDomain(id: $id) {
    id
    name
    parentDomainID
    subDomains {
      items {
        id
        name
        parentDomainID
        subDomains {
          items {
            id
            name
            parentDomainID
            createdAt
            updatedAt
            owner
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        owner
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetDomainQueryVariables, APITypes.GetDomainQuery>;
export const listDomains = /* GraphQL */ `query ListDomains(
  $filter: ModelDomainFilterInput
  $limit: Int
  $nextToken: String
) {
  listDomains(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      parentDomainID
      subDomains {
        items {
          id
          name
          parentDomainID
          subDomains {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          owner
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDomainsQueryVariables,
  APITypes.ListDomainsQuery
>;
export const getFile = /* GraphQL */ `query GetFile($id: ID!) {
  getFile(id: $id) {
    id
    name
    description
    file_type
    read_accounts
    read_groups
    full_access_groups
    data {
      bucket
      region
      key
      __typename
    }
    public
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<APITypes.GetFileQueryVariables, APITypes.GetFileQuery>;
export const listFiles = /* GraphQL */ `query ListFiles(
  $filter: ModelFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      file_type
      read_accounts
      read_groups
      full_access_groups
      data {
        bucket
        region
        key
        __typename
      }
      public
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListFilesQueryVariables, APITypes.ListFilesQuery>;
export const getGoal = /* GraphQL */ `query GetGoal($id: ID!) {
  getGoal(id: $id) {
    id
    habitatID
    emoji
    title
    type
    start
    end
    allDay
    recurrence {
      mode
      freq
      interval
      byweekday
      until
      count
      __typename
    }
    recurrenceUntil
    recurrenceInstanceMap
    recurrenceExcludeDates
    location
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    todo
    notes
    complete
    recurrenceCompletionStates
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    completions
    completions_per_period
    period
    reference_code
    readGroups
    isTemplate
    category_ids
    color
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetGoalQueryVariables, APITypes.GetGoalQuery>;
export const listGoals = /* GraphQL */ `query ListGoals(
  $filter: ModelGoalFilterInput
  $limit: Int
  $nextToken: String
) {
  listGoals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListGoalsQueryVariables, APITypes.ListGoalsQuery>;
export const getHabitat = /* GraphQL */ `query GetHabitat($id: ID!) {
  getHabitat(id: $id) {
    id
    habitatID
    name
    favouriteRecipes {
      items {
        id
        habitatID
        recipeID
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    favouriteRecipeIDs
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    imageURL
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHabitatQueryVariables,
  APITypes.GetHabitatQuery
>;
export const listHabitats = /* GraphQL */ `query ListHabitats(
  $filter: ModelHabitatFilterInput
  $limit: Int
  $nextToken: String
) {
  listHabitats(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      name
      favouriteRecipes {
        items {
          id
          habitatID
          recipeID
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      favouriteRecipeIDs
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHabitatsQueryVariables,
  APITypes.ListHabitatsQuery
>;
export const getImage = /* GraphQL */ `query GetImage($id: ID!) {
  getImage(id: $id) {
    id
    name
    habitatID
    readGroups
    data {
      bucket
      region
      key
      __typename
    }
    thumbnail {
      bucket
      region
      key
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetImageQueryVariables, APITypes.GetImageQuery>;
export const listImages = /* GraphQL */ `query ListImages(
  $filter: ModelImageFilterInput
  $limit: Int
  $nextToken: String
) {
  listImages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListImagesQueryVariables,
  APITypes.ListImagesQuery
>;
export const getIngredientGroup = /* GraphQL */ `query GetIngredientGroup($id: ID!) {
  getIngredientGroup(id: $id) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIngredientGroupQueryVariables,
  APITypes.GetIngredientGroupQuery
>;
export const listIngredientGroups = /* GraphQL */ `query ListIngredientGroups(
  $filter: ModelIngredientGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listIngredientGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIngredientGroupsQueryVariables,
  APITypes.ListIngredientGroupsQuery
>;
export const getIngredientItem = /* GraphQL */ `query GetIngredientItem($id: ID!) {
  getIngredientItem(id: $id) {
    id
    name
    groupID
    group {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    recipeGroupID
    recipeGroup {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetIngredientItemQueryVariables,
  APITypes.GetIngredientItemQuery
>;
export const listIngredientItems = /* GraphQL */ `query ListIngredientItems(
  $filter: ModelIngredientItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listIngredientItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      groupID
      group {
        id
        name
        createdAt
        updatedAt
        __typename
      }
      recipeGroupID
      recipeGroup {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListIngredientItemsQueryVariables,
  APITypes.ListIngredientItemsQuery
>;
export const getLockPin = /* GraphQL */ `query GetLockPin($user_id: ID!) {
  getLockPin(user_id: $user_id) {
    user_id
    pin
    prompt_new_pin
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLockPinQueryVariables,
  APITypes.GetLockPinQuery
>;
export const listLockPins = /* GraphQL */ `query ListLockPins(
  $user_id: ID
  $filter: ModelLockPinFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listLockPins(
    user_id: $user_id
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      user_id
      pin
      prompt_new_pin
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLockPinsQueryVariables,
  APITypes.ListLockPinsQuery
>;
export const getLogEvent = /* GraphQL */ `query GetLogEvent($id: ID!) {
  getLogEvent(id: $id) {
    id
    type
    source
    platform
    user_id
    feature_domain
    data
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogEventQueryVariables,
  APITypes.GetLogEventQuery
>;
export const listLogEvents = /* GraphQL */ `query ListLogEvents(
  $filter: ModelLogEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      source
      platform
      user_id
      feature_domain
      data
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogEventsQueryVariables,
  APITypes.ListLogEventsQuery
>;
export const getMealPlan = /* GraphQL */ `query GetMealPlan($id: ID!) {
  getMealPlan(id: $id) {
    id
    habitatID
    week
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMealPlanQueryVariables,
  APITypes.GetMealPlanQuery
>;
export const listMealPlans = /* GraphQL */ `query ListMealPlans(
  $filter: ModelMealPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  listMealPlans(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      week
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMealPlansQueryVariables,
  APITypes.ListMealPlansQuery
>;
export const getOption = /* GraphQL */ `query GetOption($id: ID!) {
  getOption(id: $id) {
    id
    type
    label
    code
    icon
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetOptionQueryVariables, APITypes.GetOptionQuery>;
export const listOptions = /* GraphQL */ `query ListOptions(
  $filter: ModelOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOptionsQueryVariables,
  APITypes.ListOptionsQuery
>;
export const getProfile = /* GraphQL */ `query GetProfile($id: ID!) {
  getProfile(id: $id) {
    id
    habitatID
    userID
    name
    email
    role
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    stockImage
    createdAt
    updatedAt
    owner
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProfileQueryVariables,
  APITypes.GetProfileQuery
>;
export const listProfiles = /* GraphQL */ `query ListProfiles(
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  listProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      userID
      name
      email
      role
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      stockImage
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProfilesQueryVariables,
  APITypes.ListProfilesQuery
>;
export const getRecipe = /* GraphQL */ `query GetRecipe($id: ID!) {
  getRecipe(id: $id) {
    id
    habitatID
    readGroups
    name
    searchField
    emoji
    description
    imageUrl
    inProgress
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    mealTypes
    dishTypeID
    dishType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    dishTypeIDs
    skillLevelID
    skillLevel {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    servingSizeID
    servingSize {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    cuisineTypeID
    cuisineType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    familyfriendlyTypeID
    familyfriendlyType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    textureTypeID
    textureType {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    specialDietIDs
    specialDiets {
      items {
        id
        recordID
        optionID
        option {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    prepTimeID
    prepTime {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    prepNotes {
      id
      title
      icon
      description
      __typename
    }
    mainIngredientID
    mainIngredient {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    health
    budget
    utensils
    ingredients {
      id
      name
      quantity
      unitOfMeasure
      category
      pantryItem
      ingredientID
      __typename
    }
    recipeIngredients {
      items {
        id
        recipeID
        display
        recipe {
          id
          habitatID
          readGroups
          name
          searchField
          emoji
          description
          imageUrl
          inProgress
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          mealTypes
          dishTypeID
          dishType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          dishTypeIDs
          skillLevelID
          skillLevel {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          servingSizeID
          servingSize {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          cuisineTypeID
          cuisineType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          familyfriendlyTypeID
          familyfriendlyType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          textureTypeID
          textureType {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          specialDietIDs
          specialDiets {
            nextToken
            __typename
          }
          prepTimeID
          prepTime {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          prepNotes {
            id
            title
            icon
            description
            __typename
          }
          mainIngredientID
          mainIngredient {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          health
          budget
          utensils
          ingredients {
            id
            name
            quantity
            unitOfMeasure
            category
            pantryItem
            ingredientID
            __typename
          }
          recipeIngredients {
            nextToken
            __typename
          }
          allergyIDs
          default_servings
          createdAt
          updatedAt
          __typename
        }
        ingredientID
        ingredient {
          items {
            id
            name
            groupID
            recipeGroupID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        quantity
        unitOfMeasure
        pantryItem
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    allergyIDs
    default_servings
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRecipeQueryVariables, APITypes.GetRecipeQuery>;
export const listRecipes = /* GraphQL */ `query ListRecipes(
  $filter: ModelRecipeFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecipes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecipesQueryVariables,
  APITypes.ListRecipesQuery
>;
export const getRecipeIngredientsGroup = /* GraphQL */ `query GetRecipeIngredientsGroup($id: ID!) {
  getRecipeIngredientsGroup(id: $id) {
    id
    recipeID
    display
    recipe {
      id
      habitatID
      readGroups
      name
      searchField
      emoji
      description
      imageUrl
      inProgress
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      mealTypes
      dishTypeID
      dishType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      dishTypeIDs
      skillLevelID
      skillLevel {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      servingSizeID
      servingSize {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      cuisineTypeID
      cuisineType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      familyfriendlyTypeID
      familyfriendlyType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      textureTypeID
      textureType {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      specialDietIDs
      specialDiets {
        items {
          id
          recordID
          optionID
          option {
            id
            type
            label
            code
            icon
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      prepTimeID
      prepTime {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      mainIngredientID
      mainIngredient {
        id
        type
        label
        code
        icon
        createdAt
        updatedAt
        __typename
      }
      health
      budget
      utensils
      ingredients {
        id
        name
        quantity
        unitOfMeasure
        category
        pantryItem
        ingredientID
        __typename
      }
      recipeIngredients {
        items {
          id
          recipeID
          display
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          ingredientID
          ingredient {
            nextToken
            __typename
          }
          quantity
          unitOfMeasure
          pantryItem
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      allergyIDs
      default_servings
      createdAt
      updatedAt
      __typename
    }
    ingredientID
    ingredient {
      items {
        id
        name
        groupID
        group {
          id
          name
          createdAt
          updatedAt
          __typename
        }
        recipeGroupID
        recipeGroup {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    quantity
    unitOfMeasure
    pantryItem
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRecipeIngredientsGroupQueryVariables,
  APITypes.GetRecipeIngredientsGroupQuery
>;
export const listRecipeIngredientsGroups = /* GraphQL */ `query ListRecipeIngredientsGroups(
  $filter: ModelRecipeIngredientsGroupFilterInput
  $limit: Int
  $nextToken: String
) {
  listRecipeIngredientsGroups(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      recipeID
      display
      recipe {
        id
        habitatID
        readGroups
        name
        searchField
        emoji
        description
        imageUrl
        inProgress
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        mealTypes
        dishTypeID
        dishType {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        dishTypeIDs
        skillLevelID
        skillLevel {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        servingSizeID
        servingSize {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        cuisineTypeID
        cuisineType {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        familyfriendlyTypeID
        familyfriendlyType {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        textureTypeID
        textureType {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        specialDietIDs
        specialDiets {
          items {
            id
            recordID
            optionID
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        prepTimeID
        prepTime {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        prepNotes {
          id
          title
          icon
          description
          __typename
        }
        mainIngredientID
        mainIngredient {
          id
          type
          label
          code
          icon
          createdAt
          updatedAt
          __typename
        }
        health
        budget
        utensils
        ingredients {
          id
          name
          quantity
          unitOfMeasure
          category
          pantryItem
          ingredientID
          __typename
        }
        recipeIngredients {
          items {
            id
            recipeID
            display
            ingredientID
            quantity
            unitOfMeasure
            pantryItem
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        allergyIDs
        default_servings
        createdAt
        updatedAt
        __typename
      }
      ingredientID
      ingredient {
        items {
          id
          name
          groupID
          group {
            id
            name
            createdAt
            updatedAt
            __typename
          }
          recipeGroupID
          recipeGroup {
            nextToken
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      quantity
      unitOfMeasure
      pantryItem
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRecipeIngredientsGroupsQueryVariables,
  APITypes.ListRecipeIngredientsGroupsQuery
>;
export const getScheduledMessage = /* GraphQL */ `query GetScheduledMessage($id: ID!) {
  getScheduledMessage(id: $id) {
    id
    dialogTrigger
    rrule
    periodOffset
    scheduledDate
    scheduledTime
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetScheduledMessageQueryVariables,
  APITypes.GetScheduledMessageQuery
>;
export const listScheduledMessages = /* GraphQL */ `query ListScheduledMessages(
  $filter: ModelScheduledMessageFilterInput
  $limit: Int
  $nextToken: String
) {
  listScheduledMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      dialogTrigger
      rrule
      periodOffset
      scheduledDate
      scheduledTime
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListScheduledMessagesQueryVariables,
  APITypes.ListScheduledMessagesQuery
>;
export const getStickyNote = /* GraphQL */ `query GetStickyNote($id: ID!) {
  getStickyNote(id: $id) {
    id
    habitatID
    content
    color
    ownerID
    owner {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    sharedWithIDs
    acknowledgements {
      user_id
      date
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetStickyNoteQueryVariables,
  APITypes.GetStickyNoteQuery
>;
export const listStickyNotes = /* GraphQL */ `query ListStickyNotes(
  $filter: ModelStickyNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  listStickyNotes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      content
      color
      ownerID
      owner {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      sharedWithIDs
      acknowledgements {
        user_id
        date
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListStickyNotesQueryVariables,
  APITypes.ListStickyNotesQuery
>;
export const getSystemProperty = /* GraphQL */ `query GetSystemProperty($name: String!) {
  getSystemProperty(name: $name) {
    name
    label
    description
    value
    read_groups
    public
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetSystemPropertyQueryVariables,
  APITypes.GetSystemPropertyQuery
>;
export const listSystemPropertys = /* GraphQL */ `query ListSystemPropertys(
  $name: String
  $filter: ModelSystemPropertyFilterInput
  $limit: Int
  $nextToken: String
  $sortDirection: ModelSortDirection
) {
  listSystemPropertys(
    name: $name
    filter: $filter
    limit: $limit
    nextToken: $nextToken
    sortDirection: $sortDirection
  ) {
    items {
      name
      label
      description
      value
      read_groups
      public
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListSystemPropertysQueryVariables,
  APITypes.ListSystemPropertysQuery
>;
export const getTaskList = /* GraphQL */ `query GetTaskList($id: ID!) {
  getTaskList(id: $id) {
    id
    habitatID
    emoji
    title
    type
    primaryIngredientList
    top
    favourite
    isAkinList
    principal {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    principalID
    participantIDS
    checklist
    image
    owner
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetTaskListQueryVariables,
  APITypes.GetTaskListQuery
>;
export const listTaskLists = /* GraphQL */ `query ListTaskLists(
  $filter: ModelTaskListFilterInput
  $limit: Int
  $nextToken: String
) {
  listTaskLists(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      emoji
      title
      type
      primaryIngredientList
      top
      favourite
      isAkinList
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      image
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListTaskListsQueryVariables,
  APITypes.ListTaskListsQuery
>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    sub
    name
    location
    username
    primary
    habitatID
    role
    email
    phoneNumber
    NDISAccountName
    NDISNumber
    birthday
    planManagerName
    planManagerEmail
    emailVerified
    carerPhone
    carerName
    supportWorkerPhone
    supportWorkerName
    contacts
    favouriteContacts
    address {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    profileColor
    profilePicture
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    customPictureURL
    systemPreferences {
      androidNotificationSoundID
      androidAlarmSoundID
      __typename
    }
    scheduledMessages {
      items {
        id
        userID
        habitatID
        scheduledMessageID
        scheduledMessage {
          id
          dialogTrigger
          rrule
          periodOffset
          scheduledDate
          scheduledTime
          createdAt
          updatedAt
          __typename
        }
        scheduledDate
        scheduledTime
        answered
        delayCount
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    endpointIds
    hasCompletedMealOnboarding
    hasViewedMealSection
    hasViewedGoalSection
    recipePreferenceOptionIDs
    onboardingToken
    hasOnboarded
    skippedOnboardingWizard
    onboardingRecipeChoices
    dashboardLayoutPreset
    chatApplicationId
    people
    budget
    time_and_effort
    dietary_balance
    allergies
    prepTime
    avoidances {
      category
      degree
      __typename
    }
    skillLevel
    is_child_profile
    use_generative_ai {
      name
      model
      max_tokens
      temperature
      __typename
    }
    favourite_recipe_ids
    contact_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getContact = /* GraphQL */ `query GetContact($id: ID!) {
  getContact(id: $id) {
    id
    habitatID
    name
    type
    tags
    phoneNumbers {
      number
      type
      __typename
    }
    emailAddresses
    addresses {
      type
      street
      city
      state
      postcode
      country
      __typename
    }
    notes
    contactColor
    stockImage
    imageID
    image {
      id
      name
      habitatID
      readGroups
      data {
        bucket
        region
        key
        __typename
      }
      thumbnail {
        bucket
        region
        key
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    publicImageURL
    user_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetContactQueryVariables,
  APITypes.GetContactQuery
>;
export const listContacts = /* GraphQL */ `query ListContacts(
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listContacts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      habitatID
      name
      type
      tags
      phoneNumbers {
        number
        type
        __typename
      }
      emailAddresses
      addresses {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      notes
      contactColor
      stockImage
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      publicImageURL
      user_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListContactsQueryVariables,
  APITypes.ListContactsQuery
>;
export const alarmByHabitat = /* GraphQL */ `query AlarmByHabitat(
  $habitatID: ID
  $start: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAlarmFilterInput
  $limit: Int
  $nextToken: String
) {
  alarmByHabitat(
    habitatID: $habitatID
    start: $start
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      participantIDS
      checklist
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      color
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AlarmByHabitatQueryVariables,
  APITypes.AlarmByHabitatQuery
>;
export const alertByHabitat = /* GraphQL */ `query AlertByHabitat(
  $habitatID: ID
  $start: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAlertFilterInput
  $limit: Int
  $nextToken: String
) {
  alertByHabitat(
    habitatID: $habitatID
    start: $start
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      participantIDS
      checklist
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      goalID
      goal {
        id
        habitatID
        emoji
        title
        type
        start
        end
        allDay
        recurrence {
          mode
          freq
          interval
          byweekday
          until
          count
          __typename
        }
        recurrenceUntil
        recurrenceInstanceMap
        recurrenceExcludeDates
        location
        principal {
          id
          sub
          name
          location
          username
          primary
          habitatID
          role
          email
          phoneNumber
          NDISAccountName
          NDISNumber
          birthday
          planManagerName
          planManagerEmail
          emailVerified
          carerPhone
          carerName
          supportWorkerPhone
          supportWorkerName
          contacts
          favouriteContacts
          address {
            type
            street
            city
            state
            postcode
            country
            __typename
          }
          profileColor
          profilePicture
          imageID
          image {
            id
            name
            habitatID
            readGroups
            createdAt
            updatedAt
            __typename
          }
          customPictureURL
          systemPreferences {
            androidNotificationSoundID
            androidAlarmSoundID
            __typename
          }
          scheduledMessages {
            nextToken
            __typename
          }
          endpointIds
          hasCompletedMealOnboarding
          hasViewedMealSection
          hasViewedGoalSection
          recipePreferenceOptionIDs
          onboardingToken
          hasOnboarded
          skippedOnboardingWizard
          onboardingRecipeChoices
          dashboardLayoutPreset
          chatApplicationId
          people
          budget
          time_and_effort
          dietary_balance
          allergies
          prepTime
          avoidances {
            category
            degree
            __typename
          }
          skillLevel
          is_child_profile
          use_generative_ai {
            name
            model
            max_tokens
            temperature
            __typename
          }
          favourite_recipe_ids
          contact_id
          createdAt
          updatedAt
          __typename
        }
        principalID
        participantIDS
        checklist
        todo
        notes
        complete
        recurrenceCompletionStates
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        imageURL
        completions
        completions_per_period
        period
        reference_code
        readGroups
        isTemplate
        category_ids
        color
        owner
        createdAt
        updatedAt
        __typename
      }
      color
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AlertByHabitatQueryVariables,
  APITypes.AlertByHabitatQuery
>;
export const eventByHabitat = /* GraphQL */ `query EventByHabitat(
  $habitatID: ID
  $start: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelEventFilterInput
  $limit: Int
  $nextToken: String
) {
  eventByHabitat(
    habitatID: $habitatID
    start: $start
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence_rule
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      color
      tags
      reminders
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.EventByHabitatQueryVariables,
  APITypes.EventByHabitatQuery
>;
export const mealByHabitat = /* GraphQL */ `query MealByHabitat(
  $habitatID: ID
  $start: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMealFilterInput
  $limit: Int
  $nextToken: String
) {
  mealByHabitat(
    habitatID: $habitatID
    start: $start
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      mealType
      start
      end
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      ingredients {
        id
        title
        checked
        shoppingListID
        __typename
      }
      prepNotes {
        id
        title
        icon
        description
        __typename
      }
      notes
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      recipes {
        items {
          id
          mealID
          recipeID
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      eaten
      recommended
      acceptedRecommended
      skipped
      meal_plan_id
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MealByHabitatQueryVariables,
  APITypes.MealByHabitatQuery
>;
export const dashboardByUser = /* GraphQL */ `query DashboardByUser(
  $user_id: ID
  $sortDirection: ModelSortDirection
  $filter: ModelDashboardFilterInput
  $limit: Int
  $nextToken: String
) {
  dashboardByUser(
    user_id: $user_id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      device_type
      user_id
      read_accounts
      read_groups
      full_access_groups
      layout
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DashboardByUserQueryVariables,
  APITypes.DashboardByUserQuery
>;
export const goalByOwner = /* GraphQL */ `query GoalByOwner(
  $owner: String
  $sortDirection: ModelSortDirection
  $filter: ModelGoalFilterInput
  $limit: Int
  $nextToken: String
) {
  goalByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      start
      end
      allDay
      recurrence {
        mode
        freq
        interval
        byweekday
        until
        count
        __typename
      }
      recurrenceUntil
      recurrenceInstanceMap
      recurrenceExcludeDates
      location
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      todo
      notes
      complete
      recurrenceCompletionStates
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      completions
      completions_per_period
      period
      reference_code
      readGroups
      isTemplate
      category_ids
      color
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GoalByOwnerQueryVariables,
  APITypes.GoalByOwnerQuery
>;
export const habitatByHabitatID = /* GraphQL */ `query HabitatByHabitatID(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelHabitatFilterInput
  $limit: Int
  $nextToken: String
) {
  habitatByHabitatID(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      name
      favouriteRecipes {
        items {
          id
          habitatID
          recipeID
          recipe {
            id
            habitatID
            readGroups
            name
            searchField
            emoji
            description
            imageUrl
            inProgress
            imageID
            mealTypes
            dishTypeID
            dishTypeIDs
            skillLevelID
            servingSizeID
            cuisineTypeID
            familyfriendlyTypeID
            textureTypeID
            specialDietIDs
            prepTimeID
            mainIngredientID
            health
            budget
            utensils
            allergyIDs
            default_servings
            createdAt
            updatedAt
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      favouriteRecipeIDs
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      imageURL
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.HabitatByHabitatIDQueryVariables,
  APITypes.HabitatByHabitatIDQuery
>;
export const logEventByType = /* GraphQL */ `query LogEventByType(
  $type: LogEventType
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogEventFilterInput
  $limit: Int
  $nextToken: String
) {
  logEventByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      source
      platform
      user_id
      feature_domain
      data
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LogEventByTypeQueryVariables,
  APITypes.LogEventByTypeQuery
>;
export const logEventByUser = /* GraphQL */ `query LogEventByUser(
  $user_id: ID
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogEventFilterInput
  $limit: Int
  $nextToken: String
) {
  logEventByUser(
    user_id: $user_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      source
      platform
      user_id
      feature_domain
      data
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LogEventByUserQueryVariables,
  APITypes.LogEventByUserQuery
>;
export const logEventByUserAndType = /* GraphQL */ `query LogEventByUserAndType(
  $user_id: ID
  $typeCreatedAt: ModelLogEventByUserAndTypeCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogEventFilterInput
  $limit: Int
  $nextToken: String
) {
  logEventByUserAndType(
    user_id: $user_id
    typeCreatedAt: $typeCreatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      source
      platform
      user_id
      feature_domain
      data
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LogEventByUserAndTypeQueryVariables,
  APITypes.LogEventByUserAndTypeQuery
>;
export const mealPlanByHabitatID = /* GraphQL */ `query MealPlanByHabitatID(
  $habitatID: ID
  $week: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMealPlanFilterInput
  $limit: Int
  $nextToken: String
) {
  mealPlanByHabitatID(
    habitatID: $habitatID
    week: $week
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      week
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MealPlanByHabitatIDQueryVariables,
  APITypes.MealPlanByHabitatIDQuery
>;
export const optionByType = /* GraphQL */ `query OptionByType(
  $type: String
  $label: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  optionByType(
    type: $type
    label: $label
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      label
      code
      icon
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OptionByTypeQueryVariables,
  APITypes.OptionByTypeQuery
>;
export const profilesByHabitat = /* GraphQL */ `query ProfilesByHabitat(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelProfileFilterInput
  $limit: Int
  $nextToken: String
) {
  profilesByHabitat(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      userID
      name
      email
      role
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      stockImage
      createdAt
      updatedAt
      owner
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProfilesByHabitatQueryVariables,
  APITypes.ProfilesByHabitatQuery
>;
export const stickyNoteByHabitat = /* GraphQL */ `query StickyNoteByHabitat(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelStickyNoteFilterInput
  $limit: Int
  $nextToken: String
) {
  stickyNoteByHabitat(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      content
      color
      ownerID
      owner {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      sharedWithIDs
      acknowledgements {
        user_id
        date
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.StickyNoteByHabitatQueryVariables,
  APITypes.StickyNoteByHabitatQuery
>;
export const tasklistByOwner = /* GraphQL */ `query TasklistByOwner(
  $owner: String
  $sortDirection: ModelSortDirection
  $filter: ModelTaskListFilterInput
  $limit: Int
  $nextToken: String
) {
  tasklistByOwner(
    owner: $owner
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      primaryIngredientList
      top
      favourite
      isAkinList
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      image
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TasklistByOwnerQueryVariables,
  APITypes.TasklistByOwnerQuery
>;
export const tasklistByHabitat = /* GraphQL */ `query TasklistByHabitat(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelTaskListFilterInput
  $limit: Int
  $nextToken: String
) {
  tasklistByHabitat(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      emoji
      title
      type
      primaryIngredientList
      top
      favourite
      isAkinList
      principal {
        id
        sub
        name
        location
        username
        primary
        habitatID
        role
        email
        phoneNumber
        NDISAccountName
        NDISNumber
        birthday
        planManagerName
        planManagerEmail
        emailVerified
        carerPhone
        carerName
        supportWorkerPhone
        supportWorkerName
        contacts
        favouriteContacts
        address {
          type
          street
          city
          state
          postcode
          country
          __typename
        }
        profileColor
        profilePicture
        imageID
        image {
          id
          name
          habitatID
          readGroups
          data {
            bucket
            region
            key
            __typename
          }
          thumbnail {
            bucket
            region
            key
            __typename
          }
          createdAt
          updatedAt
          __typename
        }
        customPictureURL
        systemPreferences {
          androidNotificationSoundID
          androidAlarmSoundID
          __typename
        }
        scheduledMessages {
          items {
            id
            userID
            habitatID
            scheduledMessageID
            scheduledDate
            scheduledTime
            answered
            delayCount
            createdAt
            updatedAt
            __typename
          }
          nextToken
          __typename
        }
        endpointIds
        hasCompletedMealOnboarding
        hasViewedMealSection
        hasViewedGoalSection
        recipePreferenceOptionIDs
        onboardingToken
        hasOnboarded
        skippedOnboardingWizard
        onboardingRecipeChoices
        dashboardLayoutPreset
        chatApplicationId
        people
        budget
        time_and_effort
        dietary_balance
        allergies
        prepTime
        avoidances {
          category
          degree
          __typename
        }
        skillLevel
        is_child_profile
        use_generative_ai {
          name
          model
          max_tokens
          temperature
          __typename
        }
        favourite_recipe_ids
        contact_id
        createdAt
        updatedAt
        __typename
      }
      principalID
      participantIDS
      checklist
      image
      owner
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.TasklistByHabitatQueryVariables,
  APITypes.TasklistByHabitatQuery
>;
export const userBySub = /* GraphQL */ `query UserBySub(
  $sub: ID
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userBySub(
    sub: $sub
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.UserBySubQueryVariables, APITypes.UserBySubQuery>;
export const userByUsername = /* GraphQL */ `query UserByUsername(
  $username: String
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByUsername(
    username: $username
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByUsernameQueryVariables,
  APITypes.UserByUsernameQuery
>;
export const userByHabitat = /* GraphQL */ `query UserByHabitat(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  userByHabitat(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      sub
      name
      location
      username
      primary
      habitatID
      role
      email
      phoneNumber
      NDISAccountName
      NDISNumber
      birthday
      planManagerName
      planManagerEmail
      emailVerified
      carerPhone
      carerName
      supportWorkerPhone
      supportWorkerName
      contacts
      favouriteContacts
      address {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      profileColor
      profilePicture
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      customPictureURL
      systemPreferences {
        androidNotificationSoundID
        androidAlarmSoundID
        __typename
      }
      scheduledMessages {
        items {
          id
          userID
          habitatID
          scheduledMessageID
          scheduledMessage {
            id
            dialogTrigger
            rrule
            periodOffset
            scheduledDate
            scheduledTime
            createdAt
            updatedAt
            __typename
          }
          scheduledDate
          scheduledTime
          answered
          delayCount
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      endpointIds
      hasCompletedMealOnboarding
      hasViewedMealSection
      hasViewedGoalSection
      recipePreferenceOptionIDs
      onboardingToken
      hasOnboarded
      skippedOnboardingWizard
      onboardingRecipeChoices
      dashboardLayoutPreset
      chatApplicationId
      people
      budget
      time_and_effort
      dietary_balance
      allergies
      prepTime
      avoidances {
        category
        degree
        __typename
      }
      skillLevel
      is_child_profile
      use_generative_ai {
        name
        model
        max_tokens
        temperature
        __typename
      }
      favourite_recipe_ids
      contact_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.UserByHabitatQueryVariables,
  APITypes.UserByHabitatQuery
>;
export const contactsByHabitat = /* GraphQL */ `query ContactsByHabitat(
  $habitatID: ID
  $sortDirection: ModelSortDirection
  $filter: ModelContactFilterInput
  $limit: Int
  $nextToken: String
) {
  contactsByHabitat(
    habitatID: $habitatID
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      habitatID
      name
      type
      tags
      phoneNumbers {
        number
        type
        __typename
      }
      emailAddresses
      addresses {
        type
        street
        city
        state
        postcode
        country
        __typename
      }
      notes
      contactColor
      stockImage
      imageID
      image {
        id
        name
        habitatID
        readGroups
        data {
          bucket
          region
          key
          __typename
        }
        thumbnail {
          bucket
          region
          key
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      publicImageURL
      user_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ContactsByHabitatQueryVariables,
  APITypes.ContactsByHabitatQuery
>;
